module.exports = __webpack_public_path__ + "static/media/exeron.5d4233e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/exeron.png
// module id = 449
// module chunks = 0